import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { TestLogin } from '@/components/test-login'
import { TestAuthService } from '@/services/test-auth-service'

export const Route = createFileRoute('/test-login')({
  beforeLoad: () => {
    if (typeof window === 'undefined') return
    if (!TestAuthService.isFeatureEnabledPublic()) {
      throw redirect({ to: '/' })
    }
    if (TestAuthService.verificarAcesso()) {
      throw redirect({ to: '/test' })
    }
  },
  component: TestLoginRoute,
})

function TestLoginRoute() {
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate({ to: '/test' })
  }

  return <TestLogin onSuccess={handleSuccess} />
}
